import { randProductName, randProductAdjective, randDepartment } from '@ngneat/falso';

import { Tradeshow, TLocations, TradeshowLocations } from '../base';

export class MockTradeshow extends Tradeshow {
   constructor( location: TLocations = TradeshowLocations[0] ) {
      super({
         location,
         name: randProductName(),
         booth: randProductAdjective(),
         exhibitor: randDepartment(),
      });
   }
}
